const CashierMessage = (props) => (
  <div className={props.className}>{props.children}</div>
);
export default CashierMessage;
